import React, { useState, useEffect } from 'react'
import { Grid, Button, Stack, Box, IconButton,Card, CardContent, Typography  } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import bgpremium from '../../assets/images/DiaryImages/bgpremium.png'
// import videaoPopup from '../../../../images/DiaryImages/videao-popup.png'
import audioDefaultWave from '../../assets/images/DiaryImages/audio-default-wave.png'
import CloseIcon from "@mui/icons-material/Close"
// import close from '../../../../images/DiaryImages/close.png'
// import startRecord from '../../../../images/DiaryImages/start-record.png'
// import news from '../../../../images/DiaryImages/new.png'
import DiaryStyles from './DiaryStyles'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'
import './DiaryCustomStyles.css'
import { ReactMediaRecorder, useReactMediaRecorder } from "react-media-recorder";
import CircleIcon from '@mui/icons-material/Circle';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';
import SaveIcon from '@mui/icons-material/Save';
import DiaryPremiumBannerStyles from './DiaryPremiumBannerStyles';
import Player from "react-wavy-audio";
import { base64UploadService, fileConvertToBase64 } from "../../helpers";
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { firebase, db, storage, auth } from '../../config/fbConfig'
var premiumbox = {
  width: '100%',
  maxHeight: '430px',
  minHeight: '430px',
  backgroundImage: `url(${bgpremium})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  paddingTop: '30px',
  borderRadius: '30px',
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  backgroundColor:"#fff",
  border: '0px solid #000',
  boxShadow: 24,
  borderRadius:'20px',
  pt: 3,
  px: 3,
  pb: 3,
};
function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{  alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35, marginTop:1 }}>
        <Typography variant="body2" align='center' color="text.secondary">{`${Math.round(
          (props.value*60)/100,
        )} sec left`}</Typography>
      </Box>
    </Box>
  );
}

const AudioRecordModal = ({
    audioModalVisible,
    onClose,
    onSave
}) => {
  const { 
    status, 
    startRecording, 
    pauseRecording, 
    resumeRecording, 
    stopRecording, 
    muteAudio, 
    unmuteAudio, 
    mediaBlobUrl,
    clearBlobUrl,
    isMuted,
    previewStream,
   } =
    useReactMediaRecorder({ 
      audio: true,
      blobPropertyBag: {
        type:"audio/wav"
      },
     });
  const [visible, setVisible] = React.useState(0);
  const classes = DiaryStyles();
  const [counter, setCounter] = React.useState(60);
  const diaryPremiumBannerClasses = DiaryPremiumBannerStyles();
  const [open, setOpen] = useState(false);
  const [audioRecordFinished, setAudioRecordFinished] = useState(false);
  const onRequestClose = (val) => {
    setAudioRecordFinished(false)
    stopRecording()
    clearBlobUrl()
    onClose()
  }
  React.useEffect(() => {
    const timer = ((counter > 0) && status == "recording") && setInterval(() => setCounter(counter - 1), 1000);
    if ((counter == 0) && status == "recording") {
      handleFinishAudioRecorder()
    }
    return () => clearInterval(timer);
  }, [counter, status]);
  const [openAudio, setOpenAudio] = useState(false)
  const handleOpenAudio = () => {
    setOpenAudio(true)
  }
  const handleStartAudioRecorder = () => {

    startRecording()
    setCounter(60)
  }
  const handlePauseAudioRecorder = () => {
    pauseRecording()
  }
  const handleResumeAudioRecorder = () => {
    resumeRecording()
  }
  const handleStopAudioRecorder = () => {
    stopRecording()
  }
  const handleFinishAudioRecorder = () => {
    stopRecording()
   
    setAudioRecordFinished(true)
    // setCounter(60)
  }
  const handleSaveAudioFiles = async() => {
    const fileSource = await fileConvertToBase64(mediaBlobUrl)
    const filePath = "diary/audio/"+ auth.currentUser.uid+"/"+new Date().getTime()+".mp3"
    const fileUrl = await base64UploadService(fileSource, filePath)
    console.log("callsed", fileUrl);
    setAudioRecordFinished(false);
    stopRecording();
    clearBlobUrl();
    onSave(fileUrl);

  }
  const handleRestartAudioRecorder = () => {
    stopRecording()
    setAudioRecordFinished(false)
    setCounter(60)
  }
  useEffect(() => {
    if(status === "stopped" && !audioRecordFinished) {
      clearBlobUrl()
    }
  }, [status,audioRecordFinished]);
  return (
    <>
      <div>
        <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={audioModalVisible}
      >
        <Stack>
          <Modal
            open={audioModalVisible}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box  sx={style}>
              <div className={diaryPremiumBannerClasses.closebtn}>
                <CloseIcon onClick={() => onRequestClose(false)} />
              </div>
              <div>
                <h4 className={diaryPremiumBannerClasses.headTex} >Record Audio</h4>
              </div>
              <Card 
              className={diaryPremiumBannerClasses.audioWaveCard}
              variant="outlined">
              <CardContent>
              {
                mediaBlobUrl?
              <Player
                audioUrl={mediaBlobUrl}
                waveStyles={{
                  cursorWidth: 1,
                  progressColor: "#ee3ec9",
                  responsive: true,
                  waveColor: "#121640",
                  cursorColor: "transparent",
                  barWidth: 0 ,
                  barGap:2,
                  barHeight:2,
                  barRadius:2,  
                }}
                zoom={0}
                hideImage={true}
              />
              : 
              <div>
                <img src={audioDefaultWave} style={{ }}></img>
              </div>
              }
              </CardContent>
              </Card>
              <LinearProgressWithLabel value={(counter*100)/60} />
              
              <div
                style={{
                  backgroundColor: '#EEEEEE',
                  padding: '10px',
                  marginTop: '10px',
                }}
              >
              <Typography variant="body1" component="p" align='center'>
              All set? Let’s start!
              </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} justifyContent='space-evenly' style={{display:'flex'}}>
                    <Button 
                    variant="contained" 
                    startIcon={
                      <CloseIcon 
                        style={{ color:"#242424"}}
                        fontSize="small"
                      />
                    }
                    className={diaryPremiumBannerClasses.finishButton}
                    onClick={() => onRequestClose(false)} 
                    >
                      Cancel
                    </Button>
                 
                  {
                    status == "idle"?
                  
                        <Button 
                        variant="contained" 
                        startIcon={
                          <CircleIcon 
                            style={{ color:"#F10019"}}
                            fontSize="small"
                          />
                        }
                        className={diaryPremiumBannerClasses.finishButton}
                        onClick={() => handleStartAudioRecorder()}
                        >
                          Start Recording
                        </Button>
                  :
                 <>
                  
                    
                    <IconButton
                      onClick={() => handleRestartAudioRecorder()}
                      className={diaryPremiumBannerClasses.pauseButton}
                     >
                    <RefreshIcon
                     fontSize ="small"
                    style={{ color:"#242424"}}
                     />
                     </IconButton>
                    {
                     ( ["recording","acquiring_media", "stopping", "stopped", "paused"].includes(status) && !audioRecordFinished)?
                     
                       <>

                       
                          {
                            ["recording"].includes(status)?
                         
                            <IconButton
                              onClick={() => handlePauseAudioRecorder()}
                              className={diaryPremiumBannerClasses.pauseButton}
                              // style={{backgroundColor: 'white'}}
                            >
                            <PauseIcon 
                              style={{ color:"#242424"}}
                              fontSize="small"
                            />
                            </IconButton>
                         
                          :
                        
                            <IconButton
                              onClick={() => handleResumeAudioRecorder()}
                              className={diaryPremiumBannerClasses.pauseButton}
                            >
                            <CircleIcon 
                              style={{ color:"#F10019"}}
                              fontSize="small"
                            />
                            </IconButton>
                         
                          }

                        
                          <Button 
                          variant="contained" 
                          startIcon={<CheckIcon />}
                          onClick={() => handleFinishAudioRecorder()}
                          className={diaryPremiumBannerClasses.finishButton}
                          >
                            Finish
                          </Button>
                       
                          </>
                     
                      :
                    
                        <LoadingButton 
                        variant="contained" 
                        startIcon={<SaveIcon />}
                        onClick={() => handleSaveAudioFiles()}
                        className={diaryPremiumBannerClasses.saveButton}
                        loadingPosition="end"
                        >
                          Save
                        </LoadingButton>
                     
                    }

                 </>
                 
                  }
                  
                 
                </Grid>
                </Grid>
              </div>
            </Box>
          </Modal>
        </Stack>
        </Backdrop>
      </div>
    </>
  )
}
export default AudioRecordModal